module.exports = __webpack_public_path__ + "static/img/80.4555a141.jpg";